
import DirectLeft from "../../../assets/filled/DirectLeft.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DirectLeftIcon({ className, dataTestid = "DirectLeftIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DirectLeft data-testid={dataTestid} className={classes} {...rest} />
  );
}
